<div class="weather-widget" *ngIf="!loading(); else loadingState">
  <div class="weather-widget__header">
    <span class="weather-widget__location">Zagreb</span>
    <span class="weather-widget__condition">{{ getLabel(weatherCode()) }}</span>
  </div>

  <div class="weather-widget__main">
    <span class="weather-widget__icon">{{ getIcon(weatherCode()) }}</span>
    <div class="weather-widget__temp">
      <span class="weather-widget__temp-value">{{ currentTemp() | number:'1.0-0' }}°</span>
      <span class="weather-widget__feels">Osjeća se kao {{ feelsLike() | number:'1.0-0' }}°</span>
    </div>
  </div>

  <div class="weather-widget__rain" [class.weather-widget__rain--active]="rainSummary().expected">
    {{ rainSummary().text }}
  </div>

  <div class="weather-widget__divider"></div>

  <div class="weather-widget__days-scroll">
    <div class="weather-widget__day-block" *ngFor="let day of dailyForecast()">
      <span class="weather-widget__day-heading">{{ day.label }}</span>

      <div class="weather-widget__scroll">
        <div class="weather-widget__grid">

          <div class="weather-widget__col weather-widget__col--label">
            <span class="weather-widget__hour-label"></span>
            <span class="weather-widget__hour-icon"></span>
            <span class="weather-widget__label-icon weather-widget__label-icon--temp">🌡️</span>
            <span class="weather-widget__label-icon">💧</span>
            <span class="weather-widget__hour-prob"></span>
          </div>

          <div class="weather-widget__col" *ngFor="let h of day.hours; let isFirst = first">
            <span class="weather-widget__hour-label">{{ isFirst && day.label === 'Danas' ? 'Sada' : (h.time | date:'HH') + 'h' }}</span>
            <span class="weather-widget__hour-icon">{{ getIcon(h.weatherCode) }}</span>
            <span class="weather-widget__hour-temp">{{ h.temperature | number:'1.0-0' }}°</span>

            <div class="weather-widget__bar-track">
              <div
                class="weather-widget__bar-fill"
                [class.weather-widget__bar-fill--warn]="h.precipitationProbability >= 40"
                [style.height.%]="h.precipitationProbability">
              </div>
            </div>
            <span class="weather-widget__hour-prob">
              {{ h.precipitationProbability >= 15 ? h.precipitationProbability + '%' : '' }}
            </span>
          </div>

        </div>
      </div>
    </div>
  </div>
</div>

<ng-template #loadingState>
  <div class="weather-widget weather-widget--loading">Učitavanje vremena...</div>
</ng-template>